import mediator from "@tvg/mediator";
import { MediatorEventType } from "./types";

export const amplitudeSetUserState = (region: string) => {
  mediator.base.dispatch({
    type: MediatorEventType.SET_USER_STATE,
    payload: {
      region
    }
  });
};

export const amplitudeSetGeoComplyStatus = (status: string) => {
  mediator.base.dispatch({
    type: MediatorEventType.GEOCOMPLY_STATUS,
    payload: {
      status
    }
  });
};

export const amplitudeRemovedGeoToken = (removedBy: string) => {
  mediator.base.dispatch({
    type: MediatorEventType.REMOVE_GEO_TOKEN,
    payload: {
      removedBy
    }
  });
};
